module.exports = __webpack_public_path__ + "img/11_debris.93e8651c.jpg";